export const breakpoints = {
  base: '0px',
  sm: '320px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1600px',
};
